import { fork, call, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';


/**
 * Get real companies
 * */
export function* getRealCompanies() {
    const response = yield call(api.getRealCompanies);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_REAL_COMPANIES.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_REAL_COMPANIES.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchGetRealCompanies() {
    while (true) {
        yield take(actionTypes.GET_REAL_COMPANIES.REQUEST);
        yield fork(getRealCompanies);
    }
}

export default [
    watchGetRealCompanies,
];




// WEBPACK FOOTER //
// ./app/sagas/realCompanies.js